import gql from "graphql-tag"

import fullHomepageLaneQuery from "./fullHomepageLaneQuery"

const fragment = gql`
  fragment fullHomepage on Homepage {
    uuid
    name
    description
    bannerTagId
    topCategoriesId
    state
    kind
    lanes {
      linkedEntityUrl
      type
      headerText
      bodyText
      image
      query {
        ...fullHomepageLaneQuery
      }
      fallbackQuery {
        ...fullHomepageLaneQuery
      }
    }
  }
  ${fullHomepageLaneQuery}
`

export const toString = fragment.loc.source.body

export default fragment
